/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BulkSimOperationsDto } from '../models/bulk-sim-operations-dto';
import { CommonDetails } from '../models/common-details';
import { SimDetailsDto } from '../models/sim-details-dto';
import { SimDetailsResponseDto } from '../models/sim-details-response-dto';

@Injectable({
  providedIn: 'root',
})
export class SimProviderControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation registerSim
   */
  static readonly RegisterSimPath = '/api/v1/registerSim';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerSim()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerSim$Response(params?: {
    body?: SimDetailsDto
  }): Observable<StrictHttpResponse<SimDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.RegisterSimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SimDetailsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerSim$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerSim(params?: {
    body?: SimDetailsDto
  }): Observable<SimDetailsDto> {

    return this.registerSim$Response(params).pipe(
      map((r: StrictHttpResponse<SimDetailsDto>) => r.body as SimDetailsDto)
    );
  }

  /**
   * Path part for operation getAllSims
   */
  static readonly GetAllSimsPath = '/api/v1/searchSims';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSims()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllSims$Response(params?: {
    page?: number;
    limit?: number;
    body?: SimDetailsDto
  }): Observable<StrictHttpResponse<SimDetailsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.GetAllSimsPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SimDetailsResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSims$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllSims(params?: {
    page?: number;
    limit?: number;
    body?: SimDetailsDto
  }): Observable<SimDetailsResponseDto> {

    return this.getAllSims$Response(params).pipe(
      map((r: StrictHttpResponse<SimDetailsResponseDto>) => r.body as SimDetailsResponseDto)
    );
  }

  /**
   * Path part for operation deleteBulkSims
   */
  static readonly DeleteBulkSimsPath = '/api/v1/deleteSims';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBulkSims()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteBulkSims$Response(params?: {
    body?: BulkSimOperationsDto
  }): Observable<StrictHttpResponse<SimDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.DeleteBulkSimsPath, 'delete');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SimDetailsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteBulkSims$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteBulkSims(params?: {
    body?: BulkSimOperationsDto
  }): Observable<SimDetailsDto> {

    return this.deleteBulkSims$Response(params).pipe(
      map((r: StrictHttpResponse<SimDetailsDto>) => r.body as SimDetailsDto)
    );
  }

  /**
   * Path part for operation getSimDetailsBySimRegistrationId
   */
  static readonly GetSimDetailsBySimRegistrationIdPath = '/api/v1/simDetails/{simRegId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSimDetailsBySimRegistrationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSimDetailsBySimRegistrationId$Response(params: {
    simRegId: string;
    body?: SimDetailsDto
  }): Observable<StrictHttpResponse<SimDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.GetSimDetailsBySimRegistrationIdPath, 'post');
    if (params) {
      rb.path('simRegId', params.simRegId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SimDetailsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSimDetailsBySimRegistrationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSimDetailsBySimRegistrationId(params: {
    simRegId: string;
    body?: SimDetailsDto
  }): Observable<SimDetailsDto> {

    return this.getSimDetailsBySimRegistrationId$Response(params).pipe(
      map((r: StrictHttpResponse<SimDetailsDto>) => r.body as SimDetailsDto)
    );
  }

  /**
   * Path part for operation activateSims
   */
  static readonly ActivateSimsPath = '/api/v1/activateSims';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateSims()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateSims$Response(params?: {
    body?: BulkSimOperationsDto
  }): Observable<StrictHttpResponse<BulkSimOperationsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.ActivateSimsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BulkSimOperationsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateSims$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateSims(params?: {
    body?: BulkSimOperationsDto
  }): Observable<BulkSimOperationsDto> {

    return this.activateSims$Response(params).pipe(
      map((r: StrictHttpResponse<BulkSimOperationsDto>) => r.body as BulkSimOperationsDto)
    );
  }

  /**
   * Path part for operation deactivateSims
   */
  static readonly DeactivateSimsPath = '/api/v1/deactivateSims';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateSims()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deactivateSims$Response(params?: {
    body?: BulkSimOperationsDto
  }): Observable<StrictHttpResponse<BulkSimOperationsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.DeactivateSimsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BulkSimOperationsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deactivateSims$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deactivateSims(params?: {
    body?: BulkSimOperationsDto
  }): Observable<BulkSimOperationsDto> {

    return this.deactivateSims$Response(params).pipe(
      map((r: StrictHttpResponse<BulkSimOperationsDto>) => r.body as BulkSimOperationsDto)
    );
  }

  /**
   * Path part for operation updateSim
   */
  static readonly UpdateSimPath = '/api/v1/editSim/{simRegId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSim()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSim$Response(params: {
    simRegId: string;
    body?: SimDetailsDto
  }): Observable<StrictHttpResponse<SimDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.UpdateSimPath, 'post');
    if (params) {
      rb.path('simRegId', params.simRegId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SimDetailsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSim$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSim(params: {
    simRegId: string;
    body?: SimDetailsDto
  }): Observable<SimDetailsDto> {

    return this.updateSim$Response(params).pipe(
      map((r: StrictHttpResponse<SimDetailsDto>) => r.body as SimDetailsDto)
    );
  }

  /**
   * Path part for operation registerBulkSim
   */
  static readonly RegisterBulkSimPath = '/api/v1/registerBulkSim';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerBulkSim()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registerBulkSim$Response(params?: {
    body?: {
'metaData'?: string;
'file'?: Blob;
}
  }): Observable<StrictHttpResponse<Array<SimDetailsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.RegisterBulkSimPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SimDetailsDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registerBulkSim$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  registerBulkSim(params?: {
    body?: {
'metaData'?: string;
'file'?: Blob;
}
  }): Observable<Array<SimDetailsDto>> {

    return this.registerBulkSim$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SimDetailsDto>>) => r.body as Array<SimDetailsDto>)
    );
  }

  /**
   * Path part for operation getAllSimProviders
   */
  static readonly GetAllSimProvidersPath = '/api/v1/simProviders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSimProviders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSimProviders$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.GetAllSimProvidersPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSimProviders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSimProviders(params?: {
  }): Observable<Array<CommonDetails>> {

    return this.getAllSimProviders$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation getProfilesBySimProviderId
   */
  static readonly GetProfilesBySimProviderIdPath = '/api/v1/simProviders/{simProviderId}/profiles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProfilesBySimProviderId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfilesBySimProviderId$Response(params: {
    simProviderId: string;
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, SimProviderControllerService.GetProfilesBySimProviderIdPath, 'get');
    if (params) {
      rb.path('simProviderId', params.simProviderId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProfilesBySimProviderId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProfilesBySimProviderId(params: {
    simProviderId: string;
  }): Observable<Array<CommonDetails>> {

    return this.getProfilesBySimProviderId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

}
